import { Checkbox } from "@legal-500/legal500-design-system";
import styles from "./EntityPicker.module.css";

export type Entity = {
  value: number | string;
  label: string;
  description?: string;
  group?: string;
};

type EntityCardProps = {
  entity: Entity;
  isSelected: boolean;
  onToggle: (entityValue: number | string) => void;
  disabled?: boolean;
  compact?: boolean;
};

export function EntityCard({
  entity,
  isSelected,
  onToggle,
  disabled = false,
  compact = false,
}: EntityCardProps) {
  const checkboxId = `entity-${entity.value}`;

  function handleCardClick() {
    if (!disabled) {
      onToggle(entity.value);
    }
  }

  function handleKeyDown(event: React.KeyboardEvent) {
    if (disabled) return;

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onToggle(entity.value);
    }
  }

  const cardClassName = [
    styles.entityCard,
    isSelected ? styles.selected : "",
    disabled ? styles.disabled : "",
    compact ? styles.compact : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={cardClassName}
      role="button"
      tabIndex={disabled ? -1 : 0}
      onClick={handleCardClick}
      onKeyDown={handleKeyDown}
      aria-pressed={isSelected}
      aria-disabled={disabled}
    >
      <div className={styles.cardContent}>
        {compact ? (
          <div className={styles.compactContent}>
            <span className={styles.compactLabel}>{entity.label}</span>
            {entity.description && (
              <span className={styles.compactDescription}>{entity.description}</span>
            )}
          </div>
        ) : (
          <>
            <div className={styles.cardHeader}>
              <span className={styles.cardLabel}>{entity.label}</span>
            </div>
            {entity.description && <p className={styles.cardDescription}>{entity.description}</p>}
          </>
        )}
      </div>

      <div className={styles.checkboxWrapper}>
        <Checkbox
          id={checkboxId}
          checked={isSelected}
          disabled={disabled}
          className={styles.checkbox}
          aria-hidden="true"
          tabIndex={-1}
          onChange={() => {
            /* noop - card handles click */
          }}
        />
      </div>
    </div>
  );
}
